import type * as OnScreenLogBundle from '@foundation-player/plugin-on-screen-log';
import { PluginFactoryFunction } from '../builder-config';
import { PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createOnScreenLogPlugin: PluginFactoryFunction = () => {
  const onScreenLogPackage = PackageName.PluginOnScreenLog;

  return [
    [onScreenLogPackage],
    () => {
      const bundle = resolveByPackageNameOrThrow<typeof OnScreenLogBundle>(onScreenLogPackage);
      return [new bundle.OnScreenLogPlugin()];
    },
  ];
};
